import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Com jugar-hi" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Esbrina el TOPÒNIM diari amagat en 6 intents. Després de cada intent, el color de les lletres canviarà per indicar la proximitat a la paraula amagada. No es tenen en compte els
        accents. Es poden repetir lletres i es poden escriure paraules d’ús comú que ajudin a trobar el nom de lloc en qüestió.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="O"
          status="correct"
        />
        <Cell value="R" />
        <Cell value="D" />
        <Cell value="A" />
        <Cell value="L" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        La lletra O es troba en el lloc correcte de la paraula.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="T" />
        <Cell value="R" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="E"
          status="present"
        />
        <Cell value="M" />
        <Cell value="P" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        La paraula té la lletra E però en un altre lloc.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="R" />
        <Cell value="E" />
        <Cell value="N" />
        <Cell isRevealing={true} isCompleted={true} value="A" status="absent" />
        <Cell value="U" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        La paraula no conté la lletra A.
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        Codi obert basat en la versió open source -{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline font-bold"
        >
          [enllaç]
        </a>{' '}
      </p>
      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        Dades obtingudes a partir dels Noms geogràfics de Catalunya (NGCat) -{' '}
        <a
          href="https://www.icgc.cat/Descarregues/Llocs/Noms-geografics-NGCat"
          className="underline font-bold"
        >
          [enllaç]
        </a>{' '}
      </p>
      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        Diccionari adaptat a partir {' '}
        <a
          href="http://diccionari.totescrable.cat/"
          className="underline font-bold"
        >
          del Diccionari de l'Scrabble (DISC)
        </a>{' '}
      </p>

    </BaseModal>
  )
}
